import { Button, Empty } from "antd";
import { PageAlert as Alert } from "@/views/components/PageAlert";

interface DetailPageErrorStateProps {
    ariaLabel: string;
    message: string;
    onBack?: () => void;
}

/**
 * 详情接口失败时保留页面壳层和空内容板块，避免错误提示替换整个业务页面。
 * 旧 Vue 详情页会继续渲染字段容器和表格空态，React 页面统一复用该降级结构。
 */
export function DetailPageErrorState({ ariaLabel, message, onBack }: DetailPageErrorStateProps) {
    return (
        <section aria-label={ariaLabel} className="detail-page-error-state">
            <Alert message={message} role="alert" type="error" />
            <div className="section-card detail-page-error-state__panel">
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据" />
            </div>
            {onBack ? <Button onClick={onBack}>返回</Button> : null}
        </section>
    );
}

export default DetailPageErrorState;
